import { useGlobalContext } from "context/GlobalContext";
import { createContext, useContext, useEffect, useState } from "react";

import { message } from "constants/responses/message";
import { finishOperationsList } from "./constants/finish.constants";
import { fetchFinishCodesApi } from "API/apis/finish/getFinish";

const FinishContext = createContext({
  currentOperationPage: "",
  setCurrentOperationPage: () => {},
  list: [],
  setList: () => {},
  previewFinish: {},
  setPreviewFinish: () => {},
  reloadRequired: false,
  setReloadRequired: () => {},
});

export const FinishProvider = ({ children }) => {
  const [list, setList] = useState([]);
  const [previewFinish, setPreviewFinish] = useState({});
  const [reloadRequired, setReloadRequired] = useState(false);
  const [currentOperationPage, setCurrentOperationPage] = useState(
    finishOperationsList.listFinish
  );

  const { setIsInitializing, setError, setIsLoading } = useGlobalContext();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsInitializing(true);
        const { data, status } = await fetchFinishCodesApi();
        if (status !== 200) {
          throw new Error(message.error.generalFailure);
        }
        setList(data);
        setIsInitializing(false);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsInitializing(false);
        setIsLoading(false);
        setReloadRequired(false);
      }
    };
    fetchData();
  }, [reloadRequired]);

  return (
    <FinishContext.Provider
      value={{
        currentOperationPage,
        setCurrentOperationPage,
        list,
        setList,
        previewFinish,
        setPreviewFinish,
        reloadRequired,
        setReloadRequired,
      }}
    >
      <>{children}</>
    </FinishContext.Provider>
  );
};

export const useFinishContext = () => {
  const context = useContext(FinishContext);
  if (!context) {
    throw new Error("useFinishContext must be used within a FinishProvider");
  }
  return context;
};
